import { FunctionComponent } from 'react'
import { Gradient } from 'types'
import { Icon, iconComponent, IconProps } from 'ui'

export const ugeLayerActions = ['duplicate', 'flip', 'send-to-back', 'delete'] as const

type UgeLayerAction = typeof ugeLayerActions[number]

export function layerActionShortName(action: UgeLayerAction): string {
    switch (action) {
        case 'delete':
            return 'Delete'
        case 'duplicate':
            return 'Duplicate'
        case 'flip':
            return 'Flip'
        case 'send-to-back':
            return 'Send to Back'
    }
}

export function layerActionName(action: UgeLayerAction): string {
    switch (action) {
        case 'flip':
            return 'Flip/Mirror'
        default:
            return layerActionShortName(action)
    }
}

export function layerActionGradient(action: UgeLayerAction): Gradient {
    switch (action) {
        case 'delete':
            return 'red-pink'
        case 'duplicate':
            return 'indigo-blue'
        case 'flip':
            return 'indigo-purple'
        case 'send-to-back':
            return 'red-yellow'
    }
}

export function layerActionIconName(action: UgeLayerAction): Icon {
    switch (action) {
        case 'delete':
            return 'trash'
        case 'duplicate':
            return 'duplicate'
        case 'flip':
            return 'flip'
        case 'send-to-back':
            return 'send-back'
    }
}

export function layerActionIcon(action: UgeLayerAction): FunctionComponent<IconProps> {
    const iconName = layerActionIconName(action)

    return iconComponent(iconName)
}

export default UgeLayerAction
